export const PRIMARY_FONT = `'Parisienne', cursive`;
export const SECONDARY_FONT = `'Mate SC', serif`;
// export const ALTERNATIVE_FONT = `'Dancing Script', cursive`;
export const ALTERNATIVE_FONT = PRIMARY_FONT;
